import axios from "axios";

export function getCompaniesDropdown() {
  return axios.get("/partner/admin/api/v1/companies/dropdown");
}

// Companies listing via account system-admin endpoint
export function getCompaniesListing(params) {
  return axios.get("/account/system-admin/api/v1/companies", { params });
}

// Company status
export function setCompanyStatus(id, data) {
  return axios.put(`/account/system-admin/api/v1/company/${id}/status`, data);
}

// White label
export function putWhiteLabel(id, data) {
  return axios.put(`/account/system-admin/api/v1/company/${id}/white_label`, data);
}

export function removeCompanyWhiteLabel(id) {
  return axios.delete(`/account/system-admin/api/v1/company/${id}/white_label`);
}

export function putBranchWhiteLabel(id, data) {
  return axios.put(`/account/system-admin/api/v1/branch/${id}/white_label`, data);
}

export function removeBranchWhiteLabel(id) {
  return axios.delete(`/account/system-admin/api/v1/branch/${id}/white_label`);
}

// Access rights
export function getAccessRights(uuid) {
  return axios.get(`/account/system-admin/api/v1/access-right/company/${uuid}`);
}

export function updateAccessRights(uuid, data) {
  return axios.post(`/account/system-admin/api/v1/access-right/company/${uuid}`, data);
}

// Plan management
export function getCompanyPlanInfo(id) {
  return axios.get(`/account/system-admin/api/v1/company/${id}/plan-info`);
}

export function updateCompanyPlan(id, data) {
  return axios.post(`/account/system-admin/api/v1/company/${id}/swap-plan`, data);
}

// Branch management
export function getNodesWithWhiteLabel(id, params) {
  return axios.get(`/account/system-admin/api/v1/company/${id}/nodes-with-white-label`, { params });
}

// Feature management
export function getFeatureGroupOption() {
  return axios.get("/account/system-admin/api/v1/feature-group-option");
}

export function getCompanyFeature(id) {
  return axios.get(`/account/system-admin/api/v1/company-feature-group/${id}`);
}

export function setCompanyFeature(id, data) {
  return axios.post(`/account/system-admin/api/v1/company-feature-group/${id}`, data);
}

export function getFeatureStructure() {
  return axios.get("/account/system-admin/api/v1/system-feature-structure");
}

// Expired date management
export function getCompanyExpiredDate(id) {
  return axios.get(`/account/system-admin/api/v1/company/${id}/expiration-info`);
}

export function updateCompanyExpiredDate(id, data) {
  return axios.put(`/account/system-admin/api/v1/company/${id}/update-expired-date`, data);
}

// Sales email
export function updateCompanySalesEmail(id, data) {
  return axios.put(`/account/system-admin/api/v1/company/${id}/sales-email`, data);
}

// Company users
export function getCompanyUsers(params) {
  return axios.get(`/account/system-admin/api/v1/company/${params.companyId}/users`, { params });
}

export function postCreditTransfer(data) {
  return axios.post("/account/system-admin/api/v1/company/user/credit-transfer", data);
}

export function postReimbursedCredit(data) {
  return axios.post("/account/system-admin/api/v1/company/user/reimbursed-credit", data);
}

// Industries (static reference data hosted on S3)
export function getIndustries() {
  const bucket = process.env.REACT_APP_S3_BUCKET_URL;
  if (!bucket) return Promise.reject(new Error("REACT_APP_S3_BUCKET_URL is not configured"));
  return axios.get(`${bucket}/constants/industries.json`, {
    transformRequest: [(data, headers) => {
      // Strip the auth header — S3 rejects requests with it.
      if (headers) delete headers.Authorization;
      return data;
    }],
  });
}

// Tags
export function getCompanyTags(uuid) {
  return axios.get(`/account/system-admin/api/v1/company/${uuid}/tag`);
}

export function putCompanyTags(uuid, data) {
  return axios.put(`/account/system-admin/api/v1/company/${uuid}/tag`, data);
}

// Impersonate
export function impersonate(uuid) {
  return axios.post(`/account/system-admin/api/v1/impersonate/${uuid}`);
}

// Serial number operations
export function getBranchListByProduct(productUuid) {
  return axios.get(`/serialnumber/system-admin/api/v1/products/nodes`, { params: { product_uuid: productUuid } });
}

export function getProductList(params) {
  return axios.get("/serialnumber/system-admin/api/v1/products/dropdown-name", { params });
}

export function getSnFormatsByBranch(id) {
  return axios.get(`/serialnumber/system-admin/api/v1/serialnumber/${id}/get-sn-formats`);
}

export function checkSnAssignAvailability(data) {
  return axios.post("/serialnumber/system-admin/api/v1/serialnumber/check-sn-availability", data);
}

export function updateAssign(data) {
  return axios.post("/distributor/system-admin/api/v1/reassignV2", data);
}

export function validateUnassignUrl(data) {
  return axios.post("/distributor/system-admin/api/v1/unassign-validate-url", data);
}

export function validateUnassignRange(data) {
  return axios.post("/distributor/system-admin/api/v1/unassign-validate", data);
}

export function updateUnassign(data) {
  return axios.post("/distributor/system-admin/api/v1/unassign", data);
}

export function updateUnassignUrl(data) {
  return axios.post("/distributor/system-admin/api/v1/unassign-url", data);
}

export function reassignNode(data) {
  return axios.post("/distributor/system-admin/api/v1/reassign-node", data);
}

export function getNodeSnRange(id) {
  return axios.get(`/serialnumber/system-admin/api/v1/serialnumber/${id}/get-node-sn-range`);
}

export function getAvailablePlans() {
  return axios.get("/account/system-admin/api/v1/approval/available-plans");
}
